/** Internal dependencies */
import { apiCall } from './apiCall';
import { handleLoadMore } from './eventHandlers/handleLoadMore';
import { getCurrentFilters } from './getCurrentFilters';
import { handleResetButton } from './eventHandlers/handleResetButton';
// import { handleFilter } from './eventHandlers/handleFilter';
import { handleDropdownFilters } from './eventHandlers/handleDropdownFilters';
import { handleButtonFilters } from './eventHandlers/handleButtonFilters';
import { prepareSearch } from './prepareSearch';
import { handleActiveFiltersContainer } from './eventHandlers/handleActiveFiltersContainer';
import { populateFiltersFromUrl } from './populateFiltersFromUrl';

/**
 * Base function for dynamically loaded contents using Ajax.
 *
 * @author Kosh <kosh@cubetech.ch>
 * @author rafhun <rafhun@cubetech.ch>
 * @export
 * @param {HTMLElement} parent The parent DOM Element
 */
export function loadAjax(parent) {
    // get the `data-ct-rest` attribute of the parent element and parse it (as it contains JSON)
    const { ctRest, ctRestInstance } = parent.dataset;
    const api = JSON.parse(ctRest);

    // Only run this function if we find the necessary API information
    if (api && api.endpoint.length) {
        // Gather relevant elements we need or want to attach events to. Make sure to only get elements within `parent`, so use `parent.querySelector()` always!
        const btnLoadMore = parent.querySelector(`[data-ct-loadmore="${ctRestInstance}"]`);
        const filterContainer = parent.querySelector(`[data-ct-filters="${ctRestInstance}"]`);
        // const btnFilter = parent.querySelector('[data-ct-filter-send]');
        const buttonFilters = parent.querySelectorAll('[data-ct-filter-type="button"]');
        const dropdownFilters = filterContainer?.querySelectorAll('[data-ct-filter-type="dropdown"]');
        const searchFilter = filterContainer?.querySelector('[data-ct-filter-type="search"]');
        const resetButtons = filterContainer?.querySelectorAll('[data-ct-filter="reset"]');
        const currentFilters = getCurrentFilters(parent);
        const activeFiltersContainer = filterContainer?.querySelector('[data-ct-filters-active]');

        // initial API call
        apiCall(parent, currentFilters, true);

        // populate filters from URL
        populateFiltersFromUrl(parent);

        // Handle events that might occur in this context

        // Load more button
        if (btnLoadMore) {
            btnLoadMore.addEventListener('click', handleLoadMore);
        }

        // // Filter button
        // if (btnFilter) {
        //     btnFilter.addEventListener('click', handleFilter);
        // }
        //
        // Handle button filters
        if (buttonFilters) {
            buttonFilters.forEach((filterGroup) => {
                filterGroup.addEventListener('click', handleButtonFilters);
            });
        }

        if (dropdownFilters) {
            dropdownFilters.forEach((filterGroup) => {
                filterGroup.addEventListener('change', handleDropdownFilters);
            });
        }

        if (searchFilter) {
            prepareSearch(searchFilter);
        }
        //
        // Reset Buttons
        if (resetButtons) {
            resetButtons.forEach((resetButton) => {
                resetButton.addEventListener('click', handleResetButton);
            });
        }

        if (activeFiltersContainer) {
            activeFiltersContainer.addEventListener('click', handleActiveFiltersContainer);
        }
    }
}
